"use strict";
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_METRIC_OPTIONS = exports.DEFAULT_CONFIG = void 0;
const core_1 = require("@opentelemetry/core");
const api = require("@opentelemetry/api");
/** Default Meter configuration. */
exports.DEFAULT_CONFIG = {
    logLevel: core_1.getEnv().OTEL_LOG_LEVEL,
};
/** The default metric creation options value. */
exports.DEFAULT_METRIC_OPTIONS = {
    disabled: false,
    description: '',
    unit: '1',
    valueType: api.ValueType.DOUBLE,
};
//# sourceMappingURL=types.js.map